<footer>

  <div class="footer-container">
    <div class="top-part">
      <div class="left-side">
        <div class="logo-wrapper">
          <a [routerLink]="appStateService.route_paths | lngRoute: 'home' : appStateService.dateTime">
            <img ngSrc="/assets/img/logo.svg" width="24" height="28" alt="selfcv logo">
            <span>selfcv</span>
          </a>
        </div>

        <div class="brand-description" [innerHTML]="'footer.what_is_selfcv' | translate"></div>

        <div class="website-share">
          <div>{{ 'footer.tell_friends_about_us' | translate }}</div>

          <div class="share-icons">
            <i class="ph ph-envelope-simple email" shareButton="email" url="https://www.selfcv.com"></i>
            <i class="ph ph-linkedin-logo linkedin" shareButton="linkedin" url="https://www.selfcv.com"></i>
            <i class="ph ph-telegram-logo telegram" shareButton="telegram" url="https://www.selfcv.com"></i>
            <i class="ph ph-facebook-logo facebook" shareButton="facebook" url="https://www.selfcv.com"></i>
            <i class="ph ph-messenger-logo messenger" shareButton="messenger" url="https://www.selfcv.com"></i>
            <i class="ph ph-whatsapp-logo whatsapp" shareButton="whatsapp" url="https://www.selfcv.com"></i>
            <i class="ph ph-phone-call viber" shareButton="viber" url="https://www.selfcv.com"></i>
            <i class="ph ph-x-logo x" shareButton="x" url="https://www.selfcv.com"></i>
            <i class="ph ph-reddit-logo reddit" shareButton="reddit" url="https://www.selfcv.com"></i>
            <i class="ph ph-pinterest-logo pinterest" shareButton="pinterest" url="https://www.selfcv.com"></i>
          </div>
        </div>
      </div>

      <div class="right-side">
        <div class="list-items-container">
          <!--<div class="list-item">
            <div>Learn</div>
            <ul>
              <li><a routerLink="/">How to write a Resume</a></li>
              <li><a routerLink="/">How to write a Cover Letter</a></li>
            </ul>
          </div>-->

          <div class="list-item">
            <div> {{ 'footer.Resources' | translate }}</div>
            <ul>
              <li>
                <a href="https://www.selfcv.com/career-blog/" target="_blank" rel="noopener">
                  {{ 'footer.Blog' | translate }}
                </a>
              </li>
              <li>
                <a href="https://www.selfcv.com/tools/" target="_blank" rel="noopener">
                  {{ 'footer.Tools' | translate }}
                </a>
              </li>
              @if (appStateService.partnerPremiumEmails.includes(appStateService.user?.email || '')) {
                <li>
                  <a routerLink="/partner-premium" target="_blank" rel="noopener">
                    Add Premium Users
                  </a>
                </li>
              }
              <li>
                <a routerLink="/resume-examples" rel="noopener">
                  {{ 'footer.Resume_Examples' | translate }}
                </a>
              </li>
            </ul>
          </div>

          <div class="list-item">
            <div>{{ 'footer.Tools' | translate }}</div>
            <ul>
              <li>
                <a href="https://www.selfcv.com/tools/crop-image/" target="_blank" rel="noopener">
                  {{ 'footer.Crop_Image' | translate }}
                </a>
              </li>
              <li>
                <a href="https://www.selfcv.com/tools/convert-base64-to-pdf/" target="_blank" rel="noopener">
                  {{ 'footer.Base64_PDF' | translate }}
                </a>
              </li>
              <li>
                <a href="https://www.selfcv.com/tools/convert-pdf-to-base64/" target="_blank" rel="noopener">
                  {{ 'footer.PDF_Base64' | translate }}
                </a>
              </li>
              <li>
                <a href="https://www.selfcv.com/tools/download-youtube-thumbnail/" target="_blank" rel="noopener">
                  {{ 'footer.YouTube_Thumbnail' | translate }}
                </a>
              </li>
              <li>
                <a href="https://www.selfcv.com/tools/" target="_blank" rel="noopener">
                  {{ 'footer.More_Tools' | translate }}
                </a>
              </li>
            </ul>
          </div>

          <div class="list-item">
            <div> {{ 'footer.Get_Started' | translate }}</div>
            <ul>
              <li>
                <a (click)="trackResumeTool('ai_generator')"
                   [routerLink]="appStateService.route_paths | lngRoute: 'ai_resume_generator' : appStateService.dateTime">
                  {{ 'footer.AI_Resume_Generator' | translate }}
                </a>
              </li>
              <!--              <li>-->
              <!--                <a [routerLink]="appStateService.route_paths | lngRoute: 'cv_templates' : appStateService.dateTime">-->
              <!--                  {{ 'footer.Resume_Examples' | translate }}-->
              <!--                </a>-->
              <!--              </li>-->

              <li>
                <a [routerLink]="appStateService.route_paths | lngRoute: 'cover_letters' : appStateService.dateTime">
                  {{ 'footer.Cover_Letter_Examples' | translate }}
                </a>
              </li>

              <li>
                <a (click)="trackResumeTool('ats_checker')"
                   [routerLink]="appStateService.route_paths | lngRoute: 'ats_checker' : appStateService.dateTime">
                  {{ 'ATS Scan' | translate }}
                </a>
              </li>

              <li>
                <a href="/job-match/" target="_blank" rel="noopener">
                  {{ 'Resume Job Matcher' | translate }}
                </a>
              </li>

              <li>
                <a [routerLink]="appStateService.route_paths | lngRoute: 'pricing' : appStateService.dateTime">
                  {{ 'footer.Pricing' | translate }}
                </a>
              </li>
              <li>
                <div class="sf-link fs-13" (click)="openChat()">
                  {{ 'footer.contact_support' | translate }}
                </div>
              </li>
              <li>
                <div class="sf-link fs-13" (click)="openEmail()" [nz-tooltip]="'support' + '@' + 'selfcv.com'">
                  {{ 'footer.send_email' | translate }}
                </div>
              </li>
            </ul>
          </div>

          <div class="list-item">
            <div>{{ 'footer.Contact' | translate }}</div>
            <ul>
              <li>
                <a [routerLink]="appStateService.route_paths | lngRoute: 'about_us' : appStateService.dateTime"
                   routerLinkActive="active">
                  {{ 'footer.About_Us' | translate }}
                </a>
              </li>

              <li>
                <a [routerLink]="appStateService.route_paths | lngRoute: 'contact_us' : appStateService.dateTime"
                   routerLinkActive="active">
                  {{ 'footer.Contact_Us' | translate }}
                </a>
              </li>

              <li>
                <a [routerLink]="appStateService.route_paths | lngRoute: 'terms_of_use' : appStateService.dateTime"
                   routerLinkActive="active">
                  {{ 'footer.Terms_Service' | translate }}
                </a>
              </li>

              <li>
                <a [routerLink]="appStateService.route_paths | lngRoute: 'privacy_policy' : appStateService.dateTime"
                   routerLinkActive="active">
                  {{ 'footer.Privacy_Policy' | translate }}
                </a>
              </li>

              <li>
                <a [routerLink]="appStateService.route_paths | lngRoute: 'refund_policy' : appStateService.dateTime"
                   routerLinkActive="active">
                  {{ 'footer.Refund_Policy' | translate }}
                </a>
              </li>

              <li>
                <a [routerLink]="appStateService.route_paths | lngRoute: 'cookie_policy' : appStateService.dateTime"
                   routerLinkActive="active">
                  {{ 'Cookie Policy' | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="top-part">
      <div class="right-side">
        <div class="list-items-container">

          @for (lng of languages; track $index; let first = $first) {
            <div class="list-item ml-0">
              @if (first) {
                <div>{{ 'footer.languages' | translate }}</div>
              } @else {
                <div class="min-h-20"></div>
              }

              <ul>
                @for (item of lng; track $index) {
                  <li>
                    <a [href]="item.href" target="_blank" rel="noopener">
                      {{ item.fName }} ({{ item.key.toUpperCase() }})
                    </a>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="languages-part">
      <div class="sf-dropdown-wrapper w-150">
        <sf-dropdown
          [unSelectable]="false"
          [hasSearch]="false"
          [additionalClassName]="'lng-dropdown'"
          [selectedItem]="appStateService.selectedLanguage"
          [items]="appStateService.languages"
          (select$)="changeLanguage($event)"
        />
      </div>
    </div>

    <div class="review-banners">
      <div class="trustpilot-widget">
        <a
          href="https://www.trustpilot.com/review/selfcv.com"
          target="_blank"
          rel="noopener"
          (click)="trustPilotReviewClicked()">
          <div>{{ 'footer.review_us' | translate }}</div>
          <img src="/assets/img/trustpilot-star.svg" alt="trustpilot selfcv">
        </a>
      </div>

      <sf-g2-love-banner/>
    </div>

    <div class="bottom-part">
      <div class="all-rights">{{ projectMessages.allRights | translate }}</div>

      <sf-project-social-icons/>
    </div>

  </div>
</footer>
